<template>
    <el-dialog v-model="dialogShow" width="80%" title="VIP与AI次数明细记录" center @close="closeEvent" append-to-body>
        <div class="login-container">
            <div class="vip-tab">
                <el-radio-group v-model="purchaseType" fill="#ef8b25" @change="purchaseTypeChange">
                    <el-radio-button label="VIP购买明细记录" value="vip" />
                    <el-radio-button label="AI次数明细记录" value="ai" />
                </el-radio-group>
            </div>
            <div style="margin:10px 0;">
                <div class="history-active">剩余：
                    <span class="activeColor">{{numObj[`${purchaseType=='ai'?'aiCallRestNum':'vipRestNum'}`]}}{{purchaseType=='ai'?'次':'天'}}</span>
                </div>

                <el-table :data="tableList" style="width: 100%" border maxHeight="38vh">
                    <el-table-column prop="memberName" label="明细记录" width="180" />
                    <el-table-column prop="type" label="方式" />
                    <el-table-column prop="days" label="天数(次)" v-if="purchaseType=='vip'">
                        <template #default="scope">
                            <el-text type="success">{{scope.row.days}}</el-text>
                        </template>
                    </el-table-column>
                    <el-table-column prop="memberAiTimes" label="次数(次)" v-if="purchaseType=='ai'">
                        <template #default="scope">
                            <el-text :type="scope.row.type=='消耗'?'warning':'success'">{{scope.row.times}}</el-text>
                        </template>
                    </el-table-column>
                    <el-table-column prop="createTime" label="时间" />
                </el-table>

                <el-config-provider :locale="zhCn" v-if="pageShow">
                    <el-pagination style="margin-top:10px;" v-model:current-page="pageInfo.current" v-model:page-size="pageInfo.size" :page-sizes="[10, 20, 30, 50]" layout="total, sizes, prev, pager, next, jumper" :total="pageInfo.total" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
                </el-config-provider>
            </div>
        </div>
    </el-dialog>
</template>
<script lang="ts" setup>
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import { ref, reactive, onMounted, defineProps, defineEmits,nextTick } from 'vue';
import { getVipHistory, getVipAiHistory, getvipInfo } from "@/api/common.js"
import { ElMessage } from 'element-plus'
import { useStore } from "vuex"
import { useRouter } from 'vue-router';
const router = useRouter();
const store = useStore();
const props = defineProps({
    popupShow: {
        type: Boolean,
        default: false
    }
})
const dialogShow = ref(props.popupShow)
const purchaseType = ref('vip')
const numObj = ref({ aiNum: 0, vipAiNum: 0 })
const emitList = defineEmits(['close'])

const tableList = ref([] as any)
const pageInfo = ref({
    current: 1,
    size: 10,
    total: 0
})
const pageShow=ref(true)

function closeEvent() {
    emitList('close')
}

function handleSizeChange(val) {
    pageInfo.value.size = val;
    getList()
}

function handleCurrentChange(val) {
    pageInfo.value.current = val;
    pageShow.value=false;
    getList()
    nextTick(()=>{
        pageShow.value=true;
    })
}

function purchaseTypeChange() {
    tableList.value = []
    pageInfo.value.total = 0;
    handleCurrentChange(1)
}

function typeFormat(row) {
    switch (row.type) {
        case 1:
            return '后台充值';
        case 2:
            return '线上充值';
        case 3:
            return '消耗';
        default:
            return row.type
    }
}

function getNum() {
    getvipInfo().then(res => {
        numObj.value = res.data || { aiCallRestNum: 0, vipRestNum: 0 }
    })
}
function getList() {
    const params = {
        current: pageInfo.value.current,
        size: pageInfo.value.size
    }
    const api = purchaseType.value == 'vip' ? getVipHistory : getVipAiHistory;
    api(params).then(res => {
        tableList.value = res.data.records || []
        pageInfo.value.total = res.data.total || 0;
    })
}

onMounted(() => {
    getNum()
    getList()
})
</script>
<style lang="scss" scoped>
@import "@/style/variable.scss";
.login-container {
    padding: 10px;
    .login-title {
        font-size: 20px;
        font-weight: bold;
        color: $base-text-color;
        margin-bottom: 10px;
    }
    .login-tabs {
        display: flex;
        font-weight: bold;
        color: $base-text-color;
        &>div {
            width: 100px;
            text-align: center;
            line-height: 24px;
        }
        .active {
            color: $base-color;
            border-bottom: 2px solid $base-color;
        }
    }
    .login-form {
        margin: 20px 0 0;
    }

    .history-active {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 10px;
    }
}
</style>